const map: any = {};
const callbacks: any = {};

export function getSVG(src: string): Promise<string> {

    return new Promise((resolve: (src: string) => void) => {

        if (map[src]) {
            resolve(map[src]);
        } else {

            if (!callbacks[src])
                callbacks[src] = [];

            callbacks[src].push(() => resolve(map[src]));

            if (callbacks[src].length === 1)
                $.ajax({
                    url: src,
                    dataType: "html",
                    type: "GET",
                    success: (data: SVGElement) => {
                        map[src] = data;
                        callbacks[src].forEach((fn: () => void) => fn())
                    }
                });
        }
    });
}

function renderIcon(i: Element): void {

    const $elem = $(i);

    const src = $elem.data("src");
    if (src) {
        $elem.attr("src", "");
        getSVG(src).then((response: string) => {
            const $svg = $($.parseHTML(response)[0]);
            $svg.addClass($elem.attr("class") || "");
            $svg.attr("id", $elem.attr("id") || "");
            $svg.attr("style", $elem.attr("style") || "");
            Object.keys($elem.data()).forEach((key: string) => {
                if (key !== "svg") $svg.data(key, $elem.data(key))
            });
            $elem.replaceWith($svg);
        });
    }
}

$(() => {
    const body: HTMLBodyElement | null = document.querySelector("body");
    const config = {
        childList: true,
        subtree: true
    };

    const observer = new MutationObserver((mutations: Array<MutationRecord>) => {
        mutations.forEach((mutation: MutationRecord) => {
            [].slice.call(mutation.addedNodes)
                .filter((node: Element) => node.nodeType === 1)
                .forEach((node: Element) => {
                    if (node.nodeName === "I" && node.classList.contains("icon")) renderIcon(node);
                    [].slice.call(node.querySelectorAll("i.icon")).forEach((i: Element) => renderIcon(i));
                });
        });
    });

    observer.observe(body as Node, config);

    const icons = [].slice.call(document.querySelectorAll("i.icon"));
    icons.forEach((i: Element) => renderIcon(i));
});